module.exports = __webpack_public_path__ + "static/media/2020.6.15快反支队助二居排水.f60e717b.jpg";